import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [s, setS] = useState({});
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  useEffect(() => { api.get("/settings").then(r => setS(r.data)); }, []);
  const submit = (e) => {
    e.preventDefault();
    toast.success("Terima kasih! Kami akan segera menghubungi Anda.");
    setForm({ name: "", email: "", message: "" });
  };
  return (
    <div data-testid="contact-page">
      <section className="lumina-bg-soft py-20">
        <div className="lumina-container">
          <div className="lumina-label mb-3">Kontak</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#1A1728] mb-6 max-w-3xl">Mari berbicara. Kami siap mendengar.</h1>
        </div>
      </section>
      <section className="lumina-container py-16 grid lg:grid-cols-2 gap-12">
        <div>
          <h2 className="font-serif text-3xl text-[#1A1728] mb-6">Informasi</h2>
          <div className="space-y-5">
            <div className="flex items-start gap-3"><Mail className="w-5 h-5 text-[#6B4BA3] mt-1" /><div><div className="font-medium">Email</div><div className="text-[#5C5870]">{s.contact_email}</div></div></div>
            <div className="flex items-start gap-3"><Phone className="w-5 h-5 text-[#6B4BA3] mt-1" /><div><div className="font-medium">Telepon</div><div className="text-[#5C5870]">{s.contact_phone}</div></div></div>
            <div className="flex items-start gap-3"><MapPin className="w-5 h-5 text-[#6B4BA3] mt-1" /><div><div className="font-medium">Alamat</div><div className="text-[#5C5870]">{s.address}</div></div></div>
          </div>
        </div>
        <form onSubmit={submit} className="lumina-card p-8" data-testid="contact-form">
          <h2 className="font-serif text-3xl text-[#1A1728] mb-6">Kirim Pesan</h2>
          <div className="space-y-4">
            <input required value={form.name} onChange={e => setForm({...form, name:e.target.value})} placeholder="Nama" className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] focus:ring-2 focus:ring-[#6B4BA3]/20 outline-none" data-testid="contact-name" />
            <input required type="email" value={form.email} onChange={e => setForm({...form, email:e.target.value})} placeholder="Email" className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] focus:ring-2 focus:ring-[#6B4BA3]/20 outline-none" data-testid="contact-email" />
            <textarea required value={form.message} onChange={e => setForm({...form, message:e.target.value})} placeholder="Pesan" rows={5} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] focus:ring-2 focus:ring-[#6B4BA3]/20 outline-none" data-testid="contact-message" />
            <button className="lumina-btn-primary w-full" data-testid="contact-submit">Kirim <Send className="w-4 h-4" /></button>
          </div>
        </form>
      </section>
    </div>
  );
}
